import { useState } from 'react';

/**
 * As ressalvas do resultado — e a fonte de cada uma.
 *
 * Esta é a tela onde o app contraria o setor. As calculadoras de biogás
 * devolvem um número limpo; esta devolve o número e o que ele está supondo.
 * A tentação de esconder isso atrás de um ícone pequeno é constante, e é
 * exatamente o que não se faz: o aviso de que o teor de sólidos veio de tabela
 * alemã é o que separa uma estimativa de um estudo levado ao banco.
 *
 * A fonte fica recolhida porque é citação acadêmica inteira — nome, periódico,
 * volume, método do ensaio. Aberta por padrão, afogaria a mensagem; ausente,
 * transformaria "segundo a literatura" em apelo à autoridade. Fica a um toque.
 */
function Ressalva({ aviso }) {
  const [vendoFonte, setVendoFonte] = useState(false);
  const grave = aviso.grave;

  return (
    <li className={`ressalva ${grave ? 'ressalva--grave' : ''}`}>
      <p className="ressalva__texto">{aviso.mensagem}</p>
      {aviso.fonte ? (
        <>
          <button
            type="button"
            className="botao botao--texto ressalva__link"
            aria-expanded={vendoFonte}
            onClick={() => setVendoFonte((v) => !v)}
          >
            {vendoFonte ? 'ocultar a fonte' : 'de onde vem esse número'}
          </button>
          {vendoFonte ? <p className="ressalva__fonte">{aviso.fonte}</p> : null}
        </>
      ) : null}
    </li>
  );
}

export function Ressalvas({ avisos = [] }) {
  if (!avisos.length) return null;

  // Grave primeiro: se existe um impedimento, ele não espera o usuário rolar.
  const ordenados = [...avisos].sort((a, b) => Number(b.grave) - Number(a.grave));

  return (
    <section className="bloco" aria-labelledby="titulo-ressalvas">
      <h2 id="titulo-ressalvas" className="rotulo-secao">
        Ressalvas ({avisos.length})
      </h2>
      <ul className="ressalvas">
        {ordenados.map((a, i) => (
          <Ressalva key={`${a.codigo}-${i}`} aviso={a} />
        ))}
      </ul>
    </section>
  );
}
